import React, { useEffect } from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import { NavBar } from "./nav-bar";

import "./header.m.css";
import { enableLogRocket } from "../helper/logger";

// Common wrapper for navigation. We could add OffcanvasMenu, Navbar etc components here.
const HeaderBase = props => {
  useEffect(() => {
    enableLogRocket();
  }, []);

  return (
    <div styleName="container">
      <NavBar {...props} />
    </div>
  );
};

function mapStateToProps(state) {
  return {
    menu: get(state, ["qt", "data", "navigationMenu"], []),
    currentPath: get(state, ["qt", "currentPath"], "")
  };
}

export const Header = connect(mapStateToProps, () => ({}))(HeaderBase);
